import { render, staticRenderFns } from "./MenuAdmin.vue?vue&type=template&id=3d3e84cf&scoped=true"
import script from "./MenuAdmin.vue?vue&type=script&lang=js"
export * from "./MenuAdmin.vue?vue&type=script&lang=js"
import style0 from "./MenuAdmin.vue?vue&type=style&index=0&id=3d3e84cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3e84cf",
  null
  
)

export default component.exports